uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

float sdCircle( vec2 p, float r )
{
    return length(p) - r;
}

float remap(float x, float a, float b, float c, float d) {
    return c + (x - a) * (d - c) / (b - a);
}

void main() {
    vec2 uv = vUv - vec2(0.5);
    vec2 screenCoords = (uv) * resolution;

    float t = mod(time * uv.x * uv.y * 100., 60.);

    float cellSize = remap(sin((t) * 0.01), -1., 1., 10., 160.);

    vec2 p = mod(screenCoords, cellSize) - (cellSize/2.);
    float r = remap(sin(time * 0.001), -1., 1., cellSize/2., cellSize/4.);
    float x = sdCircle(p, r);

    gl_FragColor = vec4(vec3(x), 1.0);
}